<app-card-content [border]="false" icon="pi pi-building" title="Consultórios" subtitle="Consultórios privados vinculados ao médico">
    <div card-header>
        <app-botao-acoes [label]="'Ações'" [items]="acoes()" [appCan]="roleConsultorioEditar" [appCanUf]="pessoa()?.uf"></app-botao-acoes>
    </div>

    <app-custom-table [metadata]="metadataTabela" [data]="dataTabela()" [loading]="loading()" [rowClickable]="true" [showExpandButton]="false" [useCustomCard]="true" [cardColumns]="2" (onRowClick)="handleSelecaoLinha($event)">
        <ng-template pTemplate="card" let-rowData>
            <!-- Clique e seleção são gerenciados pelo app-custom-table (onRowClick); não duplicar aqui para não alternar a seleção. -->
            <app-card-container [hoverEfect]="true" class="consultorio-card-item block h-full">
                <div class="consultorio-card-header">
                    <div class="consultorio-card-title-row">
                        <div class="consultorio-card-badges-row">
                            @if (rowData.situacao) {
                                <p-tag [value]="rowData.situacao.value" [rounded]="true" [style]="{ 'background-color': rowData.situacao.color, color: '#ffffff' }"></p-tag>
                            }
                            @if (rowData.tipo) {
                                <p-tag [value]="rowData.tipo.value" [rounded]="true" [style]="{ 'background-color': rowData.tipo.color, color: '#ffffff' }"></p-tag>
                            }
                        </div>
                        <h3 class="consultorio-card-title" [title]="rowData.controle">Nº Controle: {{ obterControleExibicao(rowData) }}</h3>
                    </div>
                </div>

                <div class="consultorio-card-body">
                    @if (rowData.endereco) {
                        <div class="consultorio-card-row">
                            <i class="pi pi-map-marker"></i>
                            <span class="consultorio-card-field-value">
                                Endereço: <span>{{ obterEnderecoExibicao(rowData) }}</span>
                            </span>
                        </div>
                    }

                    @if (rowData.cnes) {
                        <div class="consultorio-card-row">
                            <i class="pi pi-verified"></i>
                            <span class="consultorio-card-field-value">
                                CNES: <span>{{ rowData.cnes }}</span>
                            </span>
                        </div>
                    }
                </div>

                <!-- Ação equivalente à da tabela; stopPropagation evita alternar a seleção do card. -->
                <div class="consultorio-card-footer flex justify-end mt-2">
                    <p-button label="Visualizar" icon="pi pi-eye" severity="success" [text]="true" size="small" (click)="$event.stopPropagation(); onVisualizarLinha(rowData.source)" ariaLabel="Visualizar consultório"></p-button>
                </div>
            </app-card-container>
        </ng-template>
    </app-custom-table>
</app-card-content>
